import { modalAccessibility } from "./modalAccessibility";
const menuListItem = document.getElementsByClassName("main-menu__item");
const skipLink = document.getElementById("skip-link");
const mobileMenuContainer = document.getElementById("mobile-menu-container");
const mobileNavContainer = document.getElementById("mobile-nav-container");
const mainMenuToggle = document.getElementById("main-menu-toggle");
const mainSubmenus = document.getElementsByClassName("main-menu__submenu");
const mainSubmenusToggle = document.getElementsByClassName(
  "main-menu__submenu-toggle",
);
const mainSubmenusBackToggle = document.getElementsByClassName(
  "main-menu__submenu-back-toggle",
);
const mobileBreakpoint = 992;

// Expand/collapse main menu container.
mainMenuToggle.addEventListener("click", function (e) {
  // Check menu toggle current state to decide if we expand or collapse main menu container.
  let isOpen = this.getAttribute("aria-expanded") === "true";

  if (isOpen) {
    // Close main menu.
    closeMainMenu();

    // Close all main menu submenus.
    closeSubmenus();
  } else {
    mainMenuToggle.setAttribute("aria-expanded", "true");
    mainMenuToggle.classList.add("menu-toggle--open");

    // Open mobile menu container.
    mobileMenuContainer.classList.add("menu-container--open");

    // Add class to stop page scrolling.
    document.body.classList.add("body-freeze");

    // Trap focus in header while mobile menu container is open.
    modalAccessibility("#header");
  }
});

// Open/close Submenus.
for (let i = 0; i < mainSubmenusToggle.length; i++) {
  mainSubmenusToggle[i].addEventListener("click", function (e) {
    // Check button current state.
    let isOpen = this.getAttribute("aria-expanded") === "true";
    let subMenu = this.nextElementSibling;
    let toggleParent = this.parentElement;
    let toggleBack = this.previousElementSibling.previousElementSibling;

    // Close all submenus.
    closeSubmenus();

    if (!isOpen) {
      // Open submenu.
      subMenu.classList.add("main-menu__submenu--open");
      this.setAttribute("aria-expanded", "true");
      this.classList.add("main-menu__submenu-toggle--active");
      toggleParent.classList.add("main-menu__item--active");
      mobileNavContainer.classList.add("menu-container__mobile-menu--blue");

      // Add class to hide on mobile all list items except from the parent and the open submenu.
      Array.from(menuListItem).forEach((el) => {
        if (
          !el.classList.contains("main-menu__item--active") &&
          !el.parentElement.classList.contains("main-menu__submenu--open")
        ) {
          el.classList.add("main-menu__item--mobile-hidden");
        }
      });

      // @todo improve
      if (window.innerWidth < mobileBreakpoint) {
        // Move focus to back button on mobile devices.
        toggleBack.focus();

        // Trap focus inside submenu while it's open.
        document.addEventListener("keydown", function (e) {
          let isTabPressed = e.key === "Tab" || e.keyCode === 9;

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            return;
          }

          // if tab key is pressed move focus to close menu icon
          if (
            e.target.classList.contains("main-menu__link") &&
            e.target.parentElement.parentElement.classList.contains(
              "main-menu__submenu",
            ) &&
            e.target.parentElement.parentElement.lastElementChild ===
              e.target.parentElement
          ) {
            toggleBack.focus();
            e.preventDefault();
          }
        });
      }
    }
  });
}

// Close submenus when back to menu toggle is clicked (mobile menu).
for (let i = 0; i < mainSubmenusBackToggle.length; i++) {
  mainSubmenusBackToggle[i].addEventListener("click", function (e) {
    closeSubmenus();
  });
}

// Close submenus when esc key is pressed.
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    // Close main menu.
    closeMainMenu();

    // Close all main menu submenus.
    closeSubmenus();
  }
});

/* Close menu and submenus when skip link is clicked. */
skipLink.addEventListener("click", function () {
  // Close main menu.
  closeMainMenu();

  // Close all main menu submenus.
  closeSubmenus();
});

// Close submenus when click outside main menu.
document.addEventListener("click", function (e) {
  const mainMenu = document.querySelector(".main-menu");

  if (mainMenu && !mainMenu.contains(e.target)) {
    closeSubmenus();
  }
});

// Close submenus when focus moves to next first level item only for desktop.
for (let i = 0; i < mainSubmenus.length; i++) {
  mainSubmenus[i].addEventListener("focusout", function (e) {
    // If focus is still in the submenu and the desktop menu is shown, do nothing
    if (
      mainSubmenus[i].contains(event.relatedTarget) ||
      window.innerWidth < mobileBreakpoint
    )
      return;

    // Close submenus otherwise.
    closeSubmenus();
  });
}

function closeMainMenu() {
  mainMenuToggle.setAttribute("aria-expanded", "false");
  mainMenuToggle.classList.remove("menu-toggle--open");

  // Close mobile menu container.
  mobileMenuContainer.classList.remove("menu-container--open");

  // Remove class that stops page scrolling.
  document.body.classList.remove("body-freeze");
}

function closeSubmenus() {
  // Close all main menu submenus.
  Array.from(mainSubmenus).forEach((el) => {
    el.classList.remove("main-menu__submenu--open");
  });

  // Set expanded false for all main menu buttons.
  Array.from(mainSubmenusToggle).forEach((el) => {
    el.setAttribute("aria-expanded", "false");
    el.classList.remove("main-menu__submenu-toggle--active");
  });

  // Remove class that hides list items on mobile.
  Array.from(menuListItem).forEach((el) => {
    el.classList.remove("main-menu__item--mobile-hidden");
  });

  // Remove class that gives blue bg to menu nav on mobile.
  mobileNavContainer.classList.remove("menu-container__mobile-menu--blue");

  // Remove active class from submenu parent list item.
  Array.from(
    document.getElementsByClassName("main-menu__item--active"),
  ).forEach((el) => {
    el.classList.remove("main-menu__item--active");
  });
}

/* Window resize @todo: extend */
function reportWindowSize() {
  if (window.innerWidth > mobileBreakpoint) {
    // Close mobile main menu container.
    closeMainMenu();
  }
}
window.onresize = reportWindowSize;
